import React from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "./ContactUs.css";
import Navbar from "../Navbar";

const ContactUs = () => {
  // Geolocation of the address
  const location = {
    lat: 25.435801,
    lng: 81.846311,
  };

  return (
    <>
      <Navbar />
      <div className="contact-section container my-5">
        <h2 className="text-center mb-4">CONTACT</h2>
        <div className="card shadow-sm">
          <div className="card-body">
            {/* Inquiry Buttons */}
            <div className="d-flex justify-content-center mb-4">
              <Link to="/general-inquiry">
                <button className="btn btn-outline-danger mx-2">
                  GENERAL INQUIRY
                </button>
              </Link>
              <Link to="/bulk-inquiry">
                <button className="btn btn-outline-danger mx-2">
                  BULK INQUIRY
                </button>
              </Link>
              <Link to="/corporate-inquiry">
                <button className="btn btn-outline-danger mx-2">
                  CORPORATE INQUIRY
                </button>
              </Link>
            </div>

            {/* Address Section */}
            <div className="text-center">
              <h4 className="mb-3">Our Address</h4>
              <h5 className="mb-3 font-weight-bold">
                NATRAJ PAPER CORPORATION
              </h5>
              <p className="mb-1">
                <strong>Office :</strong> 117/130kp Kakkar Road, Prayagraj,
                Uttar Pradesh 211003
              </p>
              <p className="mb-1">
                <strong>Phone :</strong> 094152 37778
              </p>
              <p className="mb-0">
                <strong>Email :</strong>{" "}
                <a href="mailto:info@natraj.com">info@natraj.com</a>
              </p>
            </div>
          </div>
        </div>

        {/* Map Container Below Contact Section */}
        <div className="map-container mt-5">
          <MapContainer center={location} zoom={15} className="map">
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {/* Marker for the location */}
            <Marker position={location}>
              <Popup>
                <b>Natraj Paper Corporation</b>
                <br />
                117/130kp Kakkar Road, Kakkar Road, Prayagraj, Uttar Pradesh
                211003
              </Popup>
            </Marker>
          </MapContainer>
        </div>

        {/* WhatsApp Floating Button */}
        <a
          href="https://wa.me/09415237778"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
            className="whatsapp-icon"
          />
        </a>
      </div>
    </>
  );
};

export default ContactUs;
